"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetFormStepBase_1 = require("../../../../Plugin/WidgetStep/WidgetFormStepBase");
class QuestionnaireFormStepBase extends WidgetFormStepBase_1.default {
    initializeForm() {
        this.form.initialize(this.getQuestionnaire());
    }
}
exports.default = QuestionnaireFormStepBase;
